import { BREADCRUMBS_CONSTANTS, CLASSES } from '../constants/index.js';
import { getCrumbs, hideAllCrumbs, hasHiddenClass, calculateTotalCrumbsWidth, addClass, removeClass } from './utils.js';

function groupOrSkipCrumbs({ breakpointWidth, container, containerWidthRef, setHiddenCrumbs, }) {
    const crumbs = getCrumbs(container);
    const crumbsWhichShouldBeHideFirst = crumbs.filter((_, index) => index !== 0 && index !== crumbs.length - 1);
    const lastCrumb = crumbs[crumbs.length - 1];
    const hasAtLeastOneHiddenCrumb = crumbsWhichShouldBeHideFirst.some((crumb) => hasHiddenClass(crumb));
    const hasAllCrumbsHidden = crumbsWhichShouldBeHideFirst.every((crumb) => hasHiddenClass(crumb));
    const isLastCrumbHidden = hasHiddenClass(lastCrumb);
    const containerWidth = container.offsetWidth;
    const isCollapsing = containerWidthRef.current && containerWidth < containerWidthRef.current;
    const isExpanding = containerWidthRef.current && containerWidth > containerWidthRef.current;
    const isFullyCollapsed = hasAllCrumbsHidden && isLastCrumbHidden;
    const isFullyExpanded = !hasAtLeastOneHiddenCrumb && !isLastCrumbHidden;
    if ((isExpanding && isFullyExpanded) || (isCollapsing && isFullyCollapsed)) {
        containerWidthRef.current = containerWidth;
        return;
    }
    groupCrumbs({ container, containerWidthRef, setHiddenCrumbs, breakpointWidth });
}
const groupCrumbs = ({ breakpointWidth, container, containerWidthRef, setHiddenCrumbs, }) => {
    const crumbs = getCrumbs(container);
    hideAllCrumbs(crumbs, container, breakpointWidth);
    const containerWidth = container.offsetWidth;
    calculateCrumbs({
        containerWidth,
        crumbs,
        breakpointWidth,
    });
    containerWidthRef.current = containerWidth;
    const tempHiddenCrumbs = crumbs.filter((crumb) => hasHiddenClass(crumb));
    setHiddenCrumbs(tempHiddenCrumbs);
};
const BreakError = {};
function calculateCrumbs({ containerWidth, crumbs, breakpointWidth, }) {
    const crumbsWhichShouldBeHideFirst = crumbs.filter((_, index) => index !== 0 && index !== crumbs.length - 1);
    const firstCrumb = crumbs[0];
    const lastCrumb = crumbs[crumbs.length - 1];
    let currentCrumbsWidth = calculateTotalCrumbsWidth(crumbs);
    const showLastCrumbOrBreak = () => {
        if (containerWidth > breakpointWidth) {
            removeClass(lastCrumb, CLASSES.hidden);
        }
        if (crumbs.length < 2) {
            return;
        }
        const chevronWidth = crumbs.length === 2 ? 0 : BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH;
        const lastCrumbWidth = lastCrumb.offsetWidth + chevronWidth;
        const lastCrumbFitInContainer = containerWidth >= currentCrumbsWidth + lastCrumbWidth;
        if (lastCrumbFitInContainer) {
            currentCrumbsWidth += lastCrumbWidth;
            return;
        }
        addClass(lastCrumb, CLASSES.hidden);
        throw BreakError;
    };
    const showFirstCrumbOrBreak = () => {
        const firstCrumbFitInContainer = containerWidth >= currentCrumbsWidth;
        if (containerWidth > breakpointWidth) {
            removeClass(firstCrumb, CLASSES.hidden);
        }
        if (firstCrumbFitInContainer) {
            return;
        }
        throw BreakError;
    };
    const showMiddleCrumbsOrBreak = () => {
        crumbsWhichShouldBeHideFirst.forEach((crumb) => {
            const isLastHiddenCrumb = crumbs.filter((crumbToBeChecked) => hasHiddenClass(crumbToBeChecked)).length === 1;
            const dotsWidth = isLastHiddenCrumb
                ? BREADCRUMBS_CONSTANTS.DROPDOWN_TRIGGER_WIDTH + BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH
                : 0;
            if (containerWidth > breakpointWidth) {
                removeClass(crumb, CLASSES.hidden);
            }
            const crumbFitInContainer = containerWidth >
                currentCrumbsWidth - dotsWidth + crumb.offsetWidth + BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH;
            if (crumbFitInContainer) {
                currentCrumbsWidth += crumb.offsetWidth + BREADCRUMBS_CONSTANTS.CHEVRON_WIDTH;
                return;
            }
            addClass(crumb, CLASSES.hidden);
            throw BreakError;
        });
    };
    if (firstCrumb.offsetWidth > containerWidth) {
        addClass(firstCrumb, CLASSES.hidden);
        return;
    }
    try {
        showLastCrumbOrBreak();
        showFirstCrumbOrBreak();
        showMiddleCrumbsOrBreak();
    }
    catch (err) {
        if (err !== BreakError) {
            throw err;
        }
    }
}

export { calculateCrumbs, groupCrumbs, groupOrSkipCrumbs };
//# sourceMappingURL=groupCrumbs.js.map
